// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isWabaCreativeOptimizationSettingsResult = objectOf({
  id: string,
  degrees_of_freedom_spec: objectOf({
    data: arrayOf(
      objectOf({
        creative_features_spec: arrayOf(objectOf({})),
      })
    ),
  }),
});

export const isPostWabaCreativeOptimizationSettingsResult = objectOf({
  success: boolean,
});
